import React from 'react';

import { Show, SimpleShowLayout } from 'components/detail';
import { TextField, MultipleChipsField } from 'components/field';

import * as urls from './urls';


export const ShopCategoryDetail = (props) => {
  return (
    <Show detailBackendPath={urls.shopCategoryDetailBackendPath} {...props}>
      <SimpleShowLayout>
        <TextField source="id" label="Category ID"/>
        <TextField source="en" label="Name"/>
        <TextField source="translation" label="Name(Local)"/>
        <MultipleChipsField source="template_names" label="Templates"/>
        <MultipleChipsField source="item_names" label="Items"/>
      </SimpleShowLayout>
    </Show>
  )
};


// WEBPACK FOOTER //
// ./src/routes/shop/ShopTemplateDetail.js